<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Please wait while we try to retrieve your session.
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <notifications />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import api from "../services/api";

export default {
  mounted: async function () {
    this.$store.dispatch('notifications/clear');

    const response = await api.get('/account', {}, {
      'Authorization': `Bearer ${this.$route.query.token}`,
    });

    this.$store.dispatch('user/setLoggedIn', {
      user: response.data,
      token: this.$route.query.token,
    }).then(() => {
      return this.$router.push(this.$route.query.redirect || {name: 'recipe-maker'});
    }).catch((err) => {
      this.$store.dispatch('notifications/setError', 'Please check your credentials and try again.');
    })
  },
}

</script>
<style lang="scss" scoped>
    .field-icon {
        float: right;
        margin-right: 9px;
        margin-top: -27px;
        position: relative;
        z-index: 2;
    }
</style>
